import parse from 'html-react-parser';

export const ItemOverview = (props) => {
    const itemOverview = props.overview;

    return (
        <>
            <div id="listing-overview" class="listing-section">
                {/* <!-- Description --> */}
                {parse(itemOverview.description)}

                {/* <!-- Listing Contacts --> */}
                <div class="listing-links-container">
                    <ul class="listing-links contact-links">
                        {itemOverview.phone && (
                            <li><a href={"tel:" + itemOverview.phone} class="listing-links"><i class="fa fa-phone"></i> {itemOverview.phone}</a></li>
                        )}
                        {itemOverview.email && (
                            <li><a href={"mailto:" + itemOverview.email} class="listing-links"><i class="fa fa-envelope-o"></i> {itemOverview.email}</a></li>
                        )}
                        {itemOverview.website && (
                            <li><a href={itemOverview.website} target="_blank" class="listing-links"><i class="fa fa-link"></i> {itemOverview.website}</a></li>
                        )}
                    </ul>
                    <div class="clearfix"></div>
                    <ul class="listing-links">
                        {itemOverview.facebook && (
                            <li><a href={itemOverview.facebook} target="_blank" class="listing-links-fb"><i class="fa fa-facebook-square"></i> Facebook</a></li>
                        )}
                        {itemOverview.youtube && (
                            <li><a href={itemOverview.youtube} target="_blank" class="listing-links-yt"><i class="fa fa-youtube-play"></i> YouTube</a></li>
                        )}
                        {itemOverview.instagram && (
                            <li><a href={itemOverview.instagram} target="_blank" class="listing-links-ig"><i class="fa fa-instagram"></i> Instagram</a></li>
                        )}
                        {itemOverview.twitter && (
                            <li><a href={itemOverview.twitter} target="_blank" class="listing-links-tt"><i class="fa fa-twitter"></i> Twitter</a></li>
                        )}
                    </ul>
                    <div class="clearfix"></div>
                </div>
                <div class="clearfix"></div>

                {/* <!-- Amenities --> */}
                <h3 class="listing-desc-headline">Amenities</h3>
                <ul class="listing-features checkboxes margin-top-0">
                    {!!itemOverview.extras && itemOverview.extras.map((extra) => (
                        <li>{extra}</li>
                    ))}
                </ul>
            </div>
        </>
    )
}